export default "__VITE_ASSET__af166cb4__"